import HttpService from '../baseHttp'
// 配货单列表页
export const HttpGetDistribution = (data = {}) => HttpService.get('/api/v2/DeliverOrder/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 配货单取消
export const HttpCancelDistribution = (data = {}) => HttpService.get('/api/v2/DeliverOrder/batchCancel', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 配货单推送仓库
export const HttpPushToWarehouse = (data = {}) => HttpService.get('/api/v2/DeliverOrder/pushToWarehouse', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 配货单推送附件
export const HttpPushAttach = (data = {}) => HttpService.get('/api/v2/DeliverOrder/pushAttach', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 配货单详情
export const HttpGetDistributionOne = (data = {}) => HttpService.get('/api/v2/DeliverOrder/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 配货单删除附件
export const HttpDeleteAttchment = (data = {}) => HttpService.get('/api/v2/DeliverOrder/attachmentDel', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// pickup
export const HttpPickUp = (data = {}) => HttpService.get('/api/v2/DeliverOrder/pickup', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 配货单编辑
export const HttpEditOne = (data = {}) => HttpService.post('/api/v2/DeliverOrder/save', data, { headers: { "Content-Type": "application/json" } } )
// 配货单恢复正常
export const HttpRecoverNormal = (data = {}) => HttpService.get('/api/v2/DeliverOrder/recoverNormal', { params: data })
// 配货单重新提交
export const HttpResubmit = (data = {}) => HttpService.get('/api/v2/DeliverOrder/resubmit', { params: data })
// 手动回传
export const HttpManualBack = (data = {}) => HttpService.post('/api/v2/DeliverOrder/trackingReturn', data, {  headers: { "Content-Type": "application/json" } })
// 重置配货单
export const HttpResetOrder = (data = {}) => HttpService.get('/api/v2/DeliverOrder/reset', { params: data })
// 面单下载
export const HttpDownloadLabel = (data = {}) => HttpService.get('/api/v2/DeliverOrder/download', { params: data })
// 添加备注
export const HttpAddRemark = (data = {}) => HttpService.get('/api/v2/DeliverOrder/remark', { params: data })
// 批量换仓
export const HttpBatchChangeWarehouse = (data = {}) => HttpService.get('/api/v2/DeliverOrder/batchChangeWarehouse', { params: data })
// 获取模板类型
export const HttpGetTemplate = (data = {}) => HttpService.get('/api/v1/importTemplate/getTemplateByType', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });
// 批量修改最晚发货时间
export const HttpChangeLastestTime = (data = {}) => HttpService.get('/api/v2/DeliverOrder/updateLatestShipDate', { params: data });
// 修改发货方式
export const HttpSwitchIssueMethod = (data = {}) => HttpService.get('/api/v2/DeliverOrder/changeOutboundModel', { params: data });
// 卡车预约
export const HttpCreateTruck = (data = {}) => HttpService.get('/api/v2/DeliverOrder/truckReservation', { params: data });
// 获取打托信息
export const HttpGetPalletList = (data = {}) => HttpService.get('/api/v2/DeliverOrder/getPalletItem', { params: data });
// 查询所有标签
export const HttpGetAllLabel = (data = {}) => HttpService.get('/api/v1/CommonModuleLabel/findAllByOrgIdAndModule', { params: data })
// 标签保存
export const HttpSaveLabel = (data = {}, config) => HttpService.post('/api/v1/CommonModuleLabel/save', data, { headers: { "Content-Type": "application/json" } })
// 单据添加标签
export const HttpOrderAddLabel = (data = {}) => HttpService.get('/api/v2/B2cOrder/addLabel', { params: data })
// 单据移除标签
export const HttpOrderRemoveLabel = (data = {}) => HttpService.get('/api/v2/B2cOrder/removeLabel', { params: data })
// 查询收藏
export const HttpGetSearchCollect = (data = {}) => HttpService.get('/api/v1/SearchCollect/findListByUser', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 添加收藏
export const HttpAddSearchCollect = (data = {}, config) => HttpService.post('/api/v1/SearchCollect/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_UC } )
// 删除收藏
export const HttpDeleteSearchCollect = (data = {}) => HttpService.get('/api/v1/SearchCollect/batchDelete', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 按id查找收藏
export const HttpGetSearchCollectById = (data = {}) => HttpService.get('/api/v1/SearchCollect/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 发货单测算
export const HttpCalculate = (data = {}, config) => HttpService.get('/api/v2/DeliverOrder/calculate', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 购买面单
export const HttpBuyLabel = (data = {}, config) => HttpService.get('/api/v2/DeliverOrder/buylabel', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// PO附件
export const HttpPoUploadAttach = (data = {}, config) => HttpService.post('/api/v2/DeliverOrder/poUploadAttach', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 箱明细
export const HttpPoShipmentCartonItem = (data = {}, config) => HttpService.get('/api/v2/DeliverOrder/PoShipmentCartonItem/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 发货SKU换标列表
export const HttpSkuChangeLabelList = (data = {}, config) => HttpService.get('/api/v2/DeliverOrder/deliveryOrderSkuChangeLabel/getSkuChangeLabelList', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 发货SKU换标修改保存
export const HttpSkuChangeLabelSaveAll = (data = {}, config) => HttpService.post('/api/v2/DeliverOrder/deliveryOrderSkuChangeLabel/saveAll', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS })
